import React from 'react'
import styles, { layout } from '../styles'
import { PartnerSlide, Slideshow } from '../components';
import hohoLogo from '../assets/hohoLogo.jpeg'
import globeLogo from '../assets/globeLogo.jpeg'
import legacyTechLogo from '../assets/legacyTechLogo.jpeg'

const Partners = () => {
  const slides = [
    <PartnerSlide 
      logo={hohoLogo} 
      name={"Hoho Action plus"} 
      description={"Hoho Action plus is a duly registered non-profit making organisation based in Kasungu-Malawi. The main purpose of the organisation is to promote human well-being in order to reach high living standards"} 
    />,
    <PartnerSlide 
      logo={legacyTechLogo} 
      name={"LEGACYTECH"} 
      description={"Provides ICT solutions and Electronic gadget repairs"} 
    />,
    <PartnerSlide 
      logo={globeLogo} 
      name={"GLOBETECH"} 
      description={"Provides ICT solutions and Electronic gadget repairs"} 
    />
    ];
  return (
    <div className={`${layout.section} ${styles.flexCenter}`}>
      <h1 className='text-2xl mb-3'>Our Partners</h1>
      <Slideshow slides={slides} interval={10000} />
    </div>
  )
}

export default Partners
